// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bfg_a bic_tr","StrollerBoxWidget__imageCounselling":"bfg_b bic_kg"};